var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["language"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var visit = require('unist-util-visit');

var Hypher = require('hypher');

var remarkHypher = function remarkHypher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$language = options.language,
      language = _options$language === void 0 ? null : _options$language,
      rest = _objectWithoutProperties(options, _excluded);

  var opts = language ? _objectSpread(_objectSpread({}, language), rest) : _objectSpread(_objectSpread({}, require('hyphenation.en-us')), rest);
  var hyphenator = new Hypher(opts);

  var transformer = function transformer(tree) {
    visit(tree, 'text', function (node) {
      node.value = hyphenator.hyphenateText(node.value, options.minLength || 4);
    });
  };

  return transformer;
};

module.exports = remarkHypher;